import BackButton from '../components/BackButton';

export default function LeaveTracker() {
    return (
        <div className="space-y-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div className="flex flex-col gap-2">
                    <BackButton />
                    <div>
                        <h1 className="text-3xl font-bold text-text-primary tracking-tight">Leave Tracker</h1>
                        <p className="text-text-secondary mt-1">Manage your time off and view upcoming holidays.</p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center justify-center min-h-[400px] bg-surface rounded-2xl border border-border shadow-sm p-8 text-center">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                    <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold text-text-primary mb-2">Coming Soon!</h2>
                <p className="text-text-secondary max-w-md mx-auto">
                    
                </p>
            </div>
        </div>
    );
}
